import React from "react";
import { Carousel } from "react-bootstrap";
import BannerSkeleton from "./BannerSkeleton.jsx";

function HeroSection({ banners = [], isLoading, error }) {
  if (isLoading) {
    return <BannerSkeleton />;
  }

  if (error) {
    return (
      <div
        style={{ height: 70 + `vh`, display: "flex", justifyContent: "center" }}
      >
        Something went wrong: {error}
      </div>
    );
  }
  console.log(banners);
  return (
    <div
      id="carouselHacked"
      className="text-dark bg-main"
      style={{ maxHeight: 70 + `vh` }}
    >
      <Carousel fade={true}>
        {banners?.length > 0 &&
          banners.map((banner, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100"
                style={{ maxHeight: "100%" }}
                src={`${banner.banner_image.replace("media", "static")}`}
                srcSet={`${banner.banner_image.replace(
                  "media",
                  "static"
                )} 1920w,
            ${banner.banner_image.replace("media", "static")}?w=1600 1600w,
            ${banner.banner_image.replace("media", "static")}?w=1200 1200w,
            ${banner.banner_image.replace("media", "static")}?w=800 800w`}
                sizes="(max-width: 1920px) 100vw, 1920px"
                alt={"Slide " + (index + 1)}
                loading="lazy"
              />
            </Carousel.Item>
          ))}
      </Carousel>
    </div>
  );
}

export default HeroSection;
